import React, { useEffect } from 'react'
import classNames from 'classnames'

import { Item } from '../types'

import style from './index.scss'
import Pane from './pane'

const Nav: React.FC<{
  className?: string
  items: Array<Item>
  onClose: () => void
}> = ({ className, items, onClose }) => {
  useEffect(() => {
    function keyHandler(e: KeyboardEvent): void {
      if (e.key === 'Escape') {
        onClose()
      }
    }

    window.addEventListener('keydown', keyHandler)
    return () => window.removeEventListener('keydown', keyHandler)
  }, [onClose])

  return (
    <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
      className={classNames(className, style.nav)}
      onClick={onClose}
    >
      <div // eslint-disable-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        className={classNames(style.contents)}
        onClick={e => e.stopPropagation()}
      >
        <Pane items={items} onExit={onClose} />
      </div>
    </div>
  )
}

export default Nav
